import { site } from "../content/site";

export const Marquee = () => {
  const items = [...site.marquee, ...site.marquee];
  return (
    <div
      data-testid="hero-marquee"
      aria-hidden="true"
      className="border-y border-slate-200 bg-white py-5 overflow-hidden select-none"
    >
      <div className="marquee-track flex items-center gap-10 w-max">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-10 shrink-0">
            <span className="font-mono text-sm uppercase tracking-[0.22em] text-slate-500">{item}</span>
            <svg width="10" height="10" viewBox="0 0 10 10" className="text-teal-500" aria-hidden="true">
              <rect x="2.2" y="2.2" width="5.6" height="5.6" transform="rotate(45 5 5)" fill="currentColor" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
};
